import BookmarkIcon from "@heroicons/react/24/solid/BookmarkIcon";
import BriefcaseIcon from "@heroicons/react/24/solid/BriefcaseIcon";
import ChevronLeftIcon from "@heroicons/react/24/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/24/solid/ChevronRightIcon";
import HomeModernIcon from "@heroicons/react/24/solid/HomeModernIcon";
import PlayCircleIcon from "@heroicons/react/24/solid/PlayCircleIcon";
import { ButtonBase } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../assets/colors";

export const OuterWrapper = styling("div")({
  maxWidth: "1440px",
  margin: "0 auto 64px",
  height: "100%",
});

export const InnerWrapper = styling("div")({
  padding: "0 6.25rem",

  "@media (max-width: 1280px)": {
    padding: "0",
  },

  "@media (max-width: 640px)": {
    padding: "0 1rem",
  },
});

export const SectionContainer = styling("section")({
  maxWidth: "1440px",
  width: "100%",
  padding: "2rem auto",

  "@media (max-width: 1280px)": {
    padding: "0 1.5rem",
  },

  "@media (max-width: 640px)": {
    padding: "1.5rem auto",
  },
});

export const SocialMediaContainer = styling("section")({
  maxWidth: "1440px",
  padding: "0 2rem",
});

export const LinkWrapper = styling(Link)({
  width: "100%",
  height: "100%",
  textDecoration: "none",
  color: Color.black,
});

export const FlexContainer = styling(Box)({
  display: "flex",
  width: "100%",
});

export const BoxContainer = styling(Box)({
  transition: "all 0.15s ease-in-out",
});

export const HScrollContainer = styling(Stack)({
  overflowX: "scroll",
  overflowY: "hidden",

  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const TextStyled = styling(Typography)({});

export const CompanyLogo = styling("img")({
  background: Color.white,
  objectFit: "contain",
  borderRadius: "0.5rem",
  border: "1px solid rgba(0, 0, 0, 0.64)",
  userSelect: "none",

  transition: "all 0.1s ease-in-out",
});

export const ButtonStyled = styling(ButtonBase)({
  background: Color.white,
  borderRadius: "32rem",
  border: `1px solid ${Color.black}`,
  width: "2.3125rem",
  height: "2.3125rem",

  transition: "all 0.075s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      border: `1px solid ${Color.black}`,
      boxShadow: "2px 2px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-2px, -2px)",
      cursor: "pointer",
    },
  },

  "&:disabled": {
    opacity: "0.25",
    cursor: "none",
  },
});

export const DividerStyled = styling(Divider)({
  margin: "2rem 0",

  "@media (max-width: 640px)": {
    margin: "1.5rem 0",
  },
});

export const CircularProgressStyled = styling(CircularProgress)({});

export const CustomIcon = styling(SvgIcon)({
  fontSize: "1.5rem",
});

export const IndustryIconStyled = styling(HomeModernIcon)({
  height: "16px",
  width: "16px",
});

export const JobIconStyled = styling(BriefcaseIcon)({
  height: "16px",
  width: "16px",
});

export const BookmarkIconStyled = styling(BookmarkIcon)({
  color: Color.white,
  strokeWidth: "1.5px",
  transition: "all 0.1s ease-in-out",

  "&:hover ": {
    strokeWidth: "3px",
    cursor: "pointer",
  },
});

export const BookmarkFilledIconStyled = styling(BookmarkIcon)({
  color: Color.hiredlyPurple,
  strokeWidth: "1.5px",
  transition: "all 0.1s ease-in-out",

  "&:hover ": {
    strokeWidth: "3px",
    cursor: "pointer",
  },
});

export const ArrowRightIconStyled = styling(ChevronRightIcon)({
  height: "1.5rem",
  width: "1.125rem",
  marginLeft: "0.125rem",
});

export const ArrowLeftIconStyled = styling(ChevronLeftIcon)({
  height: "1.5rem",
  width: "1.125rem",
});

export const PlayIconStyled = styling(PlayCircleIcon)({
  color: Color.white,
  strokeWidth: "0.5px",
  stroke: "rgba(0, 0, 0, 0.38)",
  height: "50px",
  width: "50px",
});
